export default {
	SET_RIBBON_NOTIFICATION: (state, data) => {
        state.ribbonNotification = {
            ...state.ribbonNotification,
            ...data
        };
    },
    SET_MAIN_UI: (state, data) => {
        state.mainUI = {
            ...state.mainUI,
            ...data
        };
    },
    SET_SEARCH_INSTRUCTION: (state, data) => {
        state.searchInstruction = {
            ...state.searchInstruction,
            ...data
        };
    },
    SET_SEARCHED_ADDRESSES: (state, data) => state.searchedAddresses = { ...state.searchedAddresses, ...data },
    SET_FAVORITES: (state, data) => state.favorites = { ...state.favorites, ...data },
    SET_ACTIVE_ADDRESS: (state, address) => state.activeAddress = address,
    SET_ACTIVE_FAVORITE: (state, address) => state.activeFavorite = address,
}